"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var stylusAdapter_1 = require("../../utils/stylusAdapter");
var Switch = (function (_super) {
    tslib_1.__extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { currentChecked: _this.props.defaultChecked };
        _this.handleClick = function () {
            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange, loading = _a.loading;
            if (disabled || loading) {
                return;
            }
            var next = !_this.isChecked();
            onChange(next);
            _this.setState({ currentChecked: next });
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, disabled = _b.disabled, loading = _b.loading, size = _b.size;
            var cls = classNames(prefixCls, prefixCls + "-size-" + size, className, (_a = {},
                _a[prefixCls + "-checked"] = _this.isChecked(),
                _a[prefixCls + "-disabled"] = disabled,
                _a[prefixCls + "-loading"] = loading,
                _a));
            return (h(stylusAdapter_1.WithStylusClick, { clickHandler: _this.handleClick },
                h("button", { className: cls, style: style, role: "switch", "aria-checked": _this.isChecked(), "aria-disabled": disabled, "aria-busy": loading, tabIndex: disabled ? -1 : undefined })));
        };
        return _this;
    }
    Switch.prototype.isChecked = function () {
        var forceChecked = this.props.checked;
        var stateChecked = this.state.currentChecked;
        if (typeof forceChecked === 'boolean') {
            return forceChecked;
        }
        return stateChecked;
    };
    Switch.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Switch;
}(React.Component));
exports.default = Switch;
Switch.defaultProps = {
    prefixCls: 'dui-switch',
    defaultChecked: false,
    disabled: false,
    onChange: helper_1.emptyFn,
    size: 'default',
};
